<ng-container *ngrxLet="gatewayStore.repeaterDevices$ as repeaterDevices">
  <app-features-container
    header="{{ '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.TITLE' | translate }}"
    [overlayType]="availableOverlays.ViCareThermostat"
    [class.hide-details-btn]="
      !climateSensor && !repeaterDevices.length && !remoteControllerDevices.length
    "
  >
    <ng-container
      *ngIf="
        remoteControllerDevices.length || climateSensor || repeaterDevices.length;
        else addComponent
      "
      feature
    >
      <!-- heating.circuits.0.operating.programs.[program]\temperature -->
      <ng-container *ngIf="targetTemperature$ | async | ready as feature">
        <app-feature-tile
          feature
          data-at-heating-circuits-0-temperature
          [label]="'+INSTALLATIONS.SRC.ETRV.TARGET_TEMPERATURE' | translate"
          [value]="
            activeProgram === heatingOperatingProgramsSchema.standby
              ? noValue
              : feature?.properties?.temperature?.value +
                ' ' +
                (feature | unit: featurePropertyKey.temperature)
          "
        >
        </app-feature-tile>
      </ng-container>

      <ng-container *ngIf="status$ | async | ready as status">
        <!-- device.sensors.temperature -->
        <app-feature-tile
          feature
          data-at-cs-sensor-temperature
          *ngIf="temperature$ | async | ready as feature"
          [error]="feature | error"
          [label]="'+INSTALLATIONS.SRC.ETRV.CURRENT_TEMPERATURE' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature | value2: featurePropertyKey.value) +
                ' ' +
                (feature | unit: featurePropertyKey.value)
          }}"
          [attr.data-feature]="feature.feature"
        >
        </app-feature-tile>

        <!-- wifi lqi -->
        <app-feature-tile
          feature
          data-at-cs-wifi-lqi
          *ngIf="wifiLqi$ | async | ready as feature"
          [error]="
            (feature | error) ||
            (feature.properties?.strength &&
              feature?.properties?.strength?.value < lowLqiSignalThreshold)
          "
          [label]="'+INSTALLATIONS.SRC.ETRV.WIFI_LQI_STRENGTH.TITLE' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature | value2: featurePropertyKey.strength) + ' ' + (feature | unit: 'strength')
          }}"
          [attr.data-feature]="feature.feature"
          [class.wifi-warning]="
            feature.properties?.strength &&
            feature.properties?.strength?.value < lowLqiSignalThreshold
          "
          [iconVariant]="iconVariant.error"
        >
        </app-feature-tile>

        <!-- Repeaters wifi lqi -->
        <ng-container *ngIf="repeaterDevices.length">
          <ng-container *ngFor="let repeater of repeaterDevices">
            <app-repeaters-wifi-lqi [device]="repeater"></app-repeaters-wifi-lqi>
          </ng-container>
        </ng-container>

        <!-- thermostat.battery -->
        <app-feature-tile
          *ngIf="battery$ | async | ready as feature"
          feature
          data-at-battery
          [label]="'+INSTALLATIONS.SRC.ETRV.BATTERY_STATUS' | translate"
          value="{{
            installationService.isSrcDeviceNotConnected(status)
              ? noValue
              : (feature | value2: featurePropertyKey.level) + ' ' + (feature | unit: 'level')
          }}"
          [attr.data-feature]="feature.feature"
        ></app-feature-tile>
      </ng-container>

      <!-- device.sensors.temperature -->
      <app-feature-tile
        feature
        data-at-cs-sensor-temperature
        *ngIf="remoteControlDeviceSensorTemperature$ | async | ready as feature"
        [error]="feature | error"
        [label]="'+INSTALLATIONS.SRC.ETRV.CURRENT_TEMPERATURE' | translate"
        value="{{
          (feature | value2: featurePropertyKey.value) +
            ' ' +
            (feature | unit: featurePropertyKey.value)
        }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-tile>

      <ng-container *ngIf="remoteControllerDevices.length">
        <app-remote-controller></app-remote-controller>
      </ng-container>
    </ng-container>
  </app-features-container>

  <ng-template #addComponent>
    <app-feature-tile feature isFullWidth="true" class="add-component-wrapper">
      <button
        mat-raised-button
        color="primary"
        gtm="onOpen"
        gtmAction="Add device dialog"
        gtmCategory="commissioning"
        (click)="onAddComponent()"
      >
        {{ '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.ADD_COMPONENT_BUTTON' | translate }}
      </button>
    </app-feature-tile>
  </ng-template>
</ng-container>
